import 'promise-polyfill/dist/polyfill';
import barba from '@barba/core';
window.transitions = barba;
// For allowing scrolling in mobile nav while blocking body from scrolling
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
window.disableBodyScroll = disableBodyScroll;
window.enableBodyScroll = enableBodyScroll;
import { ResizeSensor } from 'css-element-queries';
window.ResizeSensor = ResizeSensor;
import ResizeObserver from 'resize-observer-polyfill';
window.polyfills = {};
window.polyfills.ResizeObserver = ResizeObserver;
import jquery from 'jquery';
window.jQuery = jquery;
window.$ = window.jQuery;
// Bootstrap, only loading JS for modals (util is required for modal)
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/modal';
